//external import
import React, { useState, useEffect, useMemo } from 'react'
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
//internal import
// import { closeFeedbackSPOCUrl } from '../../../../../constants/constants';
import { formattedDate } from '../../../basic-component/DateUtils';
import { useCloseFeedback } from '../../../../hooks/useCloseFeedback';
import ViewFeedbackDetails from '../../../pages/feedbackDetails/ViewFeedbackDetails';
import CloseFeedbackForm from '../../../basic-component/form-component/feedback-form/CloseFeedbackForm';
import API_Routes from '../../../../../constants/api-routes';
import FeedbackClosure from '../../../basic-component/form-component/feedback-form/FeedbackClosure';
import { closeFeedbackSPOCUrl, apiHostUrl } from '../../../../../constants/constants';
import ViewFeedbackDetailsForClose from '../../../pages/feedbackDetails/ViewFeedbackDetailsForClose.jsx';

export default function CloseFeedback({
  toggleParentModal,
  isUsedWithModal = false,
  dataUsedWithModal,
  snackBarSwitch,
  snackMsg,
  feedbackId,
  onModalCloseHandler,
  needsRefresh,
}) {
  const { csrfToken } = useSelector((state) => state.csrf);

  const { homeLink } = useSelector((state) => state.role);
  const fetchNamesUrl = apiHostUrl + homeLink + closeFeedbackSPOCUrl;

  const responseFromHook = useCloseFeedback(fetchNamesUrl, csrfToken);
  const { t } = useTranslation();
  const [response, setResponse] = useState([]);
  const [showDetails, setShowDetails] = useState(false);
  const [id, setId] = useState();
  const [formData, setFormData] = useState({
    departmentId: "318",
    feedbackId: "",
    receiptTargetId: "",
  });
  const [itemData, setItemData] = useState({});
  const handlerClick = (item) => {
    console.log("Close feedback payload ", item);
    debugger;
    item &&
      setFormData((prevPayload) => ({
        ...prevPayload,
        ["feedbackId"]: item.feedback_id,
        ["receiptTargetId"]: item.receipts.receiptTargetId,
        ["departmentId"]: item.departmentId,
        // ['feedbackId']: item.feedback_id?item.feedback_id:feedbackId,
      }));
    setItemData(item);
    setShowDetails(true);
  };
  useEffect(() => {
    console.log(isUsedWithModal, "used with modal");
    if (isUsedWithModal && dataUsedWithModal) {
      console.log("dataUsedWithModal", dataUsedWithModal);
      let feedbackId = dataUsedWithModal?.id;
      console.log("feedback id:", feedbackId);
      let receipts = dataUsedWithModal?.latestReceipt;
      let departmentId = dataUsedWithModal?.department?.id;
      let feedbackTypeDescription =
        dataUsedWithModal?.feedbackType?.description;
      handlerClick({
        feedbackType: { description: feedbackTypeDescription },
        feedback_id: feedbackId,
        receipts: receipts,
        departmentId: departmentId,
      });
    }
  }, [isUsedWithModal]);
  useEffect(() => {
    setResponse(responseFromHook);
  }, [responseFromHook]);

  const columnData = useMemo(
    () => [
      {
        accessorKey: "sl_no",
        header: t("label.new.feedbacklist.SLNo"),
      },
      {
        accessorKey: "feedback_code",
        header: t("label.new.feedbacklist.feedbackCdoe"),
      },
      {
        accessorKey: "feedback_desc",
        header: t("label.new.feedbacklist.Description"),
      },
      {
        accessorKey: "organization",
        header: t("label.new.feedbacklist.Organization"),
      },
      {
        accessorKey: "date_of_feedback",
        header: t("label.new.feedbacklist.DateOfFeedback"),
      },
      {
        accessorKey: "status",
        header: t("label.new.feedbacklist.Status"),
      },
      {
        accessorKey: "action",
        header: t("label.new.feedbacklist.Action"),
      },
    ],
    [t]
  );

  const rowsData = [];

  // response?.forEach((item, index) => {
  //     rowsData.push({
  //         sl_no: index + 1,
  //         feedback_code: item.feedbackCode,
  //         feedback_desc: item.feedbackDesc,
  //         date_of_feedback: formattedDate(item.createDate),
  //         organization: item.organizationName,
  //         status: item.latestReceipt.status,
  //         id: item.id,
  //         action: <button type="button" className="btn btn-primary" style={{ backgroundColor: 'blue' }}
  //             onClick={() => handlerClick(item)}>
  //             {t('general.label.status.resolve')}
  //         </button>,
  //     })

  // });

  return (
    <div>
      {!isUsedWithModal &&
        (showDetails ? (
          <ViewFeedbackDetailsForClose
            fetchUrl={API_Routes.getFeedbackDetailsforFeedbackCloseURL}
            body={formData}
            keyComponent={"Close"}
            renderComponent={(val) => (
              <FeedbackClosure itemData={itemData} uploadFormData={val} />
            )}
          />
        ) : (
          <CloseFeedbackForm columnData={columnData} rowsData={rowsData} />
        ))}
      {
        isUsedWithModal && (
          <FeedbackClosure
            needsRefresh={needsRefresh}
            onModalCloseHandler={onModalCloseHandler}
            toggleParentModal={toggleParentModal}
            snackBarSwitch={snackBarSwitch}
            snackMsg={snackMsg}
            itemData={itemData}
            receiptTargetId={formData.receiptTargetId}
            uploadFormData={null}
          />
        )
        // <ViewFeedbackDetailsForClose
        //     fetchUrl={API_Routes.getFeedbackDetailsforFeedbackCloseURL}
        //     body={formData}
        //     keyComponent={"Close"}
        //     renderComponent={(val) => <FeedbackClosure itemData={itemData} receiptTargetId={formData.receiptTargetId} uploadFormData={val} />}
        // />
      }
    </div>
  );
}
